(function($) {	
  $("#recipe_tag").bind("click", function () {
    var catm = $(this).attr('data-tag');
    var formatm = catm.replace(/\s+/g, '-').toLowerCase();		
    //var url = /blogs/all?recipe_tag=" + encodeURIComponent($("#category-link").val());
    var url = "/blogs/all?recipe_tag=" + formatm;
    window.location.href = url;								
  });	

  function getUrlVarsm() {
    var varsm = {};
    var partsm = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,    
      function(m,key,value) {
      varsm[key] = value;
    });
    return varsm;
  }

  var fTypem = getUrlVarsm()["recipe_tag"];

  setTimeout(function() {
    if( typeof(document.getElementById("recipe-tab")) != 'undefined'){
      //document.getElementById("recipe-tab").click();
    }  
    $('.template-blog #recipes .blog-grid > :not(li[data-id="' + fTypem + '"])').hide();
    //$( '#show-category span[data-point="' + fTypem + '"]' ).css('display','block');
  },1000);	
  // end	
  
  // Quantity buttons
  $('.qtybox .btnqty').on('click', function(){
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
  }); 

})(jQuery);